import './Basket.css';
import './LoghiPagamento.css';
import API from '../library/ApiManager'
import Loader from "react-loader-spinner";
import Fnc from '../library/Functions';
import React, { useState, useEffect } from 'react';
import DialogMsg from './DialogMsg';
import {
  useLocation
} from "react-router-dom";



function Basket(props) {

  const [loading, setLoading] = useState(null);
  const [basket, setBasket] = useState(null); //basket originario
  const [products, setProducts] = useState(null); //prodotti raggruppati da stampare
  const [dlgConf, setDlgConf] = useState(null);
  const [showErrCoupon, setShowErrCoupon] = useState(false);
  const [coupon, setCoupon] = useState(null);

  const useLocationChange = (action) => {
    const location = useLocation()
    React.useEffect(() => { action(location) }, [location, products])
  }


  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    validateBasket();

  }, [props.codComm]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento


  useLocationChange((location) => {
    Fnc.log("Cambio URL navigazione da BASKET:", location, Fnc.LogLvl.DEBUG);

    let bskAndProds = JSON.parse(sessionStorage.getItem(Fnc.prodListName));
    

    if (products && products !== null) {
      //pagina vista con checkout
      let currStep = Fnc.getStepByUrl();
      let checkStep = currStep.gaCheckoutStep;

      Fnc.gaCheckout(checkStep,bskAndProds);

    } else {
      //pagina vista normale
      let stepByUrl = Fnc.getStepByUrl();
			let pageTitle = "";
			if(stepByUrl && stepByUrl != null) {
				pageTitle = stepByUrl.desc;
			} else {
				pageTitle = props.pageTitle ? props.pageTitle : document.title;
			}
      Fnc.gaPageview(pageTitle, document.location.href, document.location.pathname);

    }
  })


  function validateBasket() {

    setLoading(true);
    //-----
    API.basketValidation((data) => {
      analizeBaksetData(data);
      setLoading(false);

    });

  }

  function analizeBaksetData(data) {
    if (data) {

      setDlgConf(null);

      if (data.response && data.response.code === 'OK') {
        setBasket(data);

        if (data.basket && data.basket.product && data.basket.product.length > 0) {

          // cerco di capire se ci sono prodotti misti, solo pay, solo ricontatto
          let prevProd = data.basket.product.find(function (el) {
            return el.properties && el.properties !== null && el.properties.quote === 'quote';
          });
          let payProd = data.basket.product.find(function (el) {
            return !el.properties || el.properties === null || !el.properties.quote || el.properties.quote === null || el.properties.quote !== 'quote';
          });
          let bskType = Fnc.BasketType.PAY;
          if (prevProd && payProd) {
            bskType = Fnc.BasketType.BOTH;
          } else if (!prevProd && payProd) {
            bskType = Fnc.BasketType.PAY;
          } else if (prevProd && !payProd) {
            bskType = Fnc.BasketType.PREV;
          }

          //raggruppa i prodotti per correlation id
          const grouped = Fnc.groupBy(data.basket.product, prod => prod.correlationId)

          let productsArr = [];
          //scorre i prodotti raggruppati per calcolare le somme e le descrizioni
          for (const [key, value] of grouped.entries()) {

            let newProd = {};

            let price = 0;
            let promoPrice = 0;
            let prorataPrice = 0;
            if (value && value.length > 1) {
              //BUNDLE

              // ---- Fonte Olcelli => si è deciso che in caso di multi prodotto, non bundle SF, ci saranno sempre 1 SOLO prodotto master e N prodotti correlati aggiunti dallo strato di Ghise con proprietà "invisibile"
              let visibleProd = value.find(function (el) { //prendo quindi il primo prodotto non "invisibile" e lo uso per la descrizione del pacchetto.
                return !el.properties || el.properties === null || el.properties.invisble !== 'invisible';
              })
              let bundleDesc = visibleProd.bundleDesc && visibleProd.bundleDesc.length > 0 ? visibleProd.bundleDesc : visibleProd.name;
              let prodCode = visibleProd.bundleCode && visibleProd.bundleCode.length > 0 ? visibleProd.bundleCode : visibleProd.code;

              value.forEach(elm => {
                if (!elm.properties || elm.properties.invisble !== 'invisible') {
                  newProd.id = elm.id;
                  newProd.correlationId = key;
                  newProd.description = bundleDesc;
                  newProd.qt = elm.quantity;
                  newProd.type = Fnc.EnmProdType.PAY; //Fonte OLCELLI : i prodotti bundle sono sempre acquistabili direttamente, senza cioè richieste di preventivo
                  newProd.code = prodCode;
                  price = price + (parseFloat(elm.price) * elm.quantity);
                  promoPrice = promoPrice + (elm.properties && elm.properties.promoprice ? parseFloat(elm.properties.promoprice) * elm.quantity : 0);
                  prorataPrice = prorataPrice + (elm.properties && elm.properties.prorata ? parseFloat(elm.properties.prorata) * elm.quantity : 0);
                }
              });
            } else if (value && value.length === 1) {
              //SCAFFALE
              let thisProd = value[0];
              newProd.id = thisProd.id;
              newProd.correlationId = key;
              newProd.description = thisProd.bundleId && thisProd.bundleId.length > 0 ? thisProd.bundleDesc : thisProd.name;
              newProd.qt = thisProd.quantity;
              newProd.type = !thisProd.properties || thisProd.properties.quote !== 'quote' ? Fnc.EnmProdType.PAY : Fnc.EnmProdType.PREV;
              newProd.code = thisProd.code;
              price = thisProd.price * thisProd.quantity;
              promoPrice = thisProd.properties && thisProd.properties.promoprice ? parseFloat(thisProd.properties.promoprice) * thisProd.quantity : null;
              prorataPrice = thisProd.properties && thisProd.properties.prorata ? parseFloat(thisProd.properties.prorata) * thisProd.quantity : null;
            }
            newProd.price = price > 0 ? parseFloat(price.toFixed(2)) : null;
            newProd.promoPrice = promoPrice > 0 ? parseFloat(promoPrice.toFixed(2)) : null;
            newProd.prorataPrice = prorataPrice > 0 ? parseFloat(prorataPrice.toFixed(2)) : null;
            productsArr.push(newProd)

          }

          Fnc.log("PRODOTTI: ", productsArr, Fnc.LogLvl.DEBUG);
          setProducts(productsArr);



          let bskAndProds = {};
          bskAndProds.prodFiltered = productsArr;
          bskAndProds.amountVat = data.basket.amountBasketVAT;
          bskAndProds.justVat = (data.basket.amountBasketVAT - data.basket.amountBasket).toFixed(2);
          bskAndProds.coupon = data.basket.coupon;

          // ======== GESTIONE RULES =========================
          if (data.rule) {
            if (data.rule.then.code !== "RULE_PRODUCT_NO_APPLY") {
              //escludo regole che scattano per il setting del copuon

              if (data.rule.then.code === "RULE47" || data.rule.then.code === "RULE48" || data.rule.then.code === "RULE1010") {
                // === RULE DOMINIO SITO ===
                let obBskRsp = {};
                obBskRsp.data = data;
                obBskRsp.type = bskType;
                obBskRsp.bskAndProds = bskAndProds;
                props.callback(new Fnc.Ret(Fnc.EnmBasket.EMPTY_DOMAIN, obBskRsp));

              } else if (data.rule.then.code === 'RULE_CONTRACTDATE_GRACE_CC') {
                // Grace period scaduto. Blocchiamo utente con msg personalizzato
                Fnc.gaException("[Basket.js@analizeBaksetData] [ "+ data.rule.then.code +" ]", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
                setDlgConf(new Fnc.DlgConf("[" + data.rule.then.code + "] Contratto scaduto", "Non è possibile finalizzare l’acquisto perchè il contratto è scaduto", true, "Chiudi", "", () => {
                  Fnc.resetBskAndHome();
                }))
                let obBskRsp = {};
                obBskRsp.data = data;
                obBskRsp.type = bskType;
                obBskRsp.bskAndProds = bskAndProds;
                props.callback(new Fnc.Ret(Fnc.EnmBasket.KO, obBskRsp));
              
              } else {
                //RULE GESTITA GENERICAMENTE
                Fnc.gaException("[Basket.js@analizeBaksetData] [ "+ data.rule.then.code +" ]", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
                setDlgConf(new Fnc.DlgConf("[" + data.rule.then.code + "] Carrello non valido", "Il carrello contiene prodotti che non puoi acquistare", true, "Chiudi", "", () => {
                  Fnc.resetBskAndHome();
                }))
                let obBskRsp = {};
                obBskRsp.data = data;
                obBskRsp.type = bskType;
                obBskRsp.bskAndProds = bskAndProds;
                props.callback(new Fnc.Ret(Fnc.EnmBasket.KO, obBskRsp));

              }
            }
            // =======================

          } else {
            let obBskRsp = {};
            obBskRsp.bskAndProds = bskAndProds;
            obBskRsp.data = data;
            obBskRsp.type = bskType;
            props.callback(new Fnc.Ret(Fnc.EnmBasket.OK, obBskRsp));
          }

        } else {
          //Carrello senza prodotti
          Fnc.gaException("[Basket.js@analizeBaksetData] Carrello senza prodotti", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
          setDlgConf(new Fnc.DlgConf("Carrello non valido", "Il carrello è vuoto", false, "Chiudi", "", () => {
            Fnc.resetBskAndHome();
          }));
          setProducts(null);
          let obBskRsp = {};
          obBskRsp.data = data;
          props.callback(new Fnc.Ret(Fnc.EnmBasket.EMPTY, obBskRsp));
        }

      } else {
        setBasket(null);
        Fnc.gaException("[Basket.js@analizeBaksetData] Carrello in KO", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
        setDlgConf(new Fnc.DlgConf("[SRVKO] Carrello non valido", "Il carrello è vuoto", true, "Chiudi", "", () => {
          Fnc.resetBskAndHome();
        }));
        let obBskRsp = {};
        obBskRsp.data = data;
        props.callback(new Fnc.Ret(Fnc.EnmBasket.EMPTY, obBskRsp));
      }


    } else {
      setBasket(null);
      props.callback(new Fnc.Ret(Fnc.EnmBasket.KO));
      setDlgConf(new Fnc.DlgConf("[SRVEMPTY] Carrello non valido", "Il carrello non è valido", true, "Chiudi", "", () => {
        Fnc.resetBskAndHome();
      }));
      Fnc.gaException("[Basket.js@analizeBaksetData] Il carrello è vuoto", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
    }
  }

  function onProductRemove(correlationId) {

    setDlgConf(new Fnc.DlgConf("Eliminare il prodotto?", "Vuoi eliminare questo prodotto definitivamente dal tuo carrello?", false, "Conferma", "Annulla",
      () => {
        let prdsToDel = basket.basket.product.filter(function (el) {
          return el.correlationId === correlationId;
        })

        let ids = [];
        prdsToDel.forEach(elm => {
          ids.push(elm.id);
        });

        API.basketDelItem(ids.join(","), (data) => {
          Fnc.log("DELETED", ids, Fnc.LogLvl.INFO);
          validateBasket();
        });
      },
      () => {

      }))

  }

  function onCouponChange(e) {
    let val = e.target.value;
    setCoupon(val);
  }

  function sendCoupon() {

    //-----
    if (coupon && coupon.length > 0) {
      setLoading(true);
      API.sendCoupon(coupon, (data) => {
        if (data && data.response && data.response.code === 'OK') {
          if (data.rule && data.rule.then.code === 'RULE_PRODUCT_NO_APPLY') {
            setShowErrCoupon(true);
            Fnc.gaException("[Basket.js@sendCoupon] Coupon non valido", coupon, false, Fnc.ExcCatgory.BASKET.val);
          } else {
            setShowErrCoupon(false);
          }
          analizeBaksetData(data);
        } else {
          setShowErrCoupon(true);
        }
        setLoading(false);
      });
    }

  }

  function remouveCoupon() {

    setLoading(true);
    setCoupon(null);
    setDlgConf(null);
    //-----
    API.sendCoupon(null, (data) => {
      const dlg = new Fnc.DlgConf("[RULE_REMOVE_COUPON] Coupon errore", "Ci sono problemi a rimuovere il coupon", true, "Chiudi", "");
      if (data && data.response && data.response.code === 'OK') {
        if (data.rule && data.rule.then.code === 'RULE_REMOVE_COUPON') {
          //errore
          setDlgConf(dlg);
          Fnc.gaException("[Basket.js@remouveCoupon] Impossibile rimuovere il coupon (RULE_REMOVE_COUPON)", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
        } else {
          //ok, rimosso
          setShowErrCoupon(false);
          analizeBaksetData(data);
        }

      } else {
        setDlgConf(dlg);
        Fnc.gaException("[Basket.js@remouveCoupon] Impossibile rimuovere il coupon (KO)", JSON.stringify(data), true, Fnc.ExcCatgory.BASKET.val);
      }
      setLoading(false);
    });

  }


  function getProdByType(type) {
    return products && products !== null ? products.filter(p => {
      return p.type === type;
    }) : [];
  }


  return (
    <>
      <div className="iol-checkout-right-part col-xl-4 offset-xl-1" >
        {getProdByType(Fnc.EnmProdType.PAY).length > 0 &&
          <div className="iol-checkout-right">
            <>
              <div className="iol-checkout-pricing">
                <div className="checkout-offer-title semibold basketTitle">La tua scelta <Loader visible={loading} className="loadingSpinnerBsk" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></div>
                <div className="caption semibold">servizi con acquisto online </div>
                <div className="iol-prices-box">
                  {getProdByType(Fnc.EnmProdType.PAY).map((prod, index) => (
                    <div key={prod.id} className="iol-product">
                      <div key={`icon_${prod.id}`} onClick={() => onProductRemove(prod.correlationId)} className="icon-remove"></div>
                      <div key={`name_${prod.id}`} className="heading-6 prod-description">{prod.description} {(prod.qt > 1) && "(qt: " + prod.qt + ")"}</div>
                      <div className="prices">
                        <div key={`price_${prod.id}`} className={`price-relative price heading-6 semibold ${(prod.promoPrice !== null || prod.prorataPrice !== null) && "price-removed"}`}>€ {prod.price}</div>
                        {prod.promoPrice !== null ?
                          <div key={`pricepromo_${prod.id}`} className="price-relative price heading-6 semibold pricepromo">€ {prod.promoPrice}</div>
                          :
                          prod.prorataPrice !== null ?
                            <div key={`pricepromo_${prod.id}`} className="price-relative price heading-6 semibold pricepromo">€ {prod.prorataPrice}</div>
                            :
                            <></>
                        }
                      </div>
                    </div>
                  ))}
                </div>
                {(basket && basket.basket && basket.basket.coupon && basket.basket.coupon.length > 0) &&
                  <div className="iol-discount-box">
                    <div className="iol-discount-text">Codice applicato</div>
                    <div className="iol-discount semibold">- € {basket && basket.basket && basket.basket.saving}</div>
                  </div>
                }
                <div className="iol-iva-box">
                  <div className="iol-iva-text">IVA 22%</div>
                  <div className="iol-iva semibold">€ {basket && basket.basket && (basket.basket.amountBasketVAT - basket.basket.amountBasket).toFixed(2)}</div>
                </div>
                <div className="iol-amount-box">
                  <div className="iol-amount-text semibold">Totale </div>
                  <div className="iol-amount semibold">€ {basket && basket.basket && basket.basket.amountBasketVAT}</div>
                </div>
              </div>
              {(basket && basket.basket && (basket.basket.coupon === null || basket.basket.coupon.length <= 0)) &&
                <div className="iol-promotional-code-box iol-error">
                  <div className="iol-promotional-code">
                    <input className="iol-code semibold" type="code" placeholder="Codice promozionale" onBlur={onCouponChange} />
                    <button className="iol-code-button" onClick={sendCoupon}>Aggiorna</button>
                  </div>
                  {showErrCoupon && <div className="iol-error-label caption semibold fucsia-text">Il codice inserito non è valido</div>}
                </div>
              }
              {(basket && basket.basket && basket.basket.coupon && basket.basket.coupon.length > 0) &&
                <div className="iol-promotional-code-box iol-code-applied">
                  <div className="iol-promotional-code">
                    <input className="iol-code semibold" disabled="disabled" type="code" placeholder={basket.basket.coupon} />
                    <button className="iol-code-button" onClick={remouveCoupon}>Rimuovi</button>
                  </div>
                </div>
              }
            </>
          </div>
        }
        {getProdByType(Fnc.EnmProdType.PAY).length > 0 &&
          <div className="iol-checkout-right">
            <div className="iol-logos logosPayMethod">
              <div className="logoMastercard logoPayMethod" alt="logo Mastercard" />
              <div className="logoVisa logoPayMethod" alt="logo Visa" />
              <div className="logoAmericanExpress logoPayMethod" alt="logo American Express" />
              <div className="logoPaypal logoPayMethod" alt="logo Paypal" />
            </div>
          </div>
        }
        {getProdByType(Fnc.EnmProdType.PREV).length > 0 &&
          <div className="iol-checkout-right">
            <div className="iol-checkout-pricing">
              <div className="checkout-offer-title semibold">Richieste preventivo</div>
              <div className="caption semibold">servizi con richiesta preventivo</div>
              <div className="iol-prices-box">
                {getProdByType(Fnc.EnmProdType.PREV).map((prod, index) => (
                  <div className="iol-product" key={prod.correlationId}>
                    <div className="icon-remove" onClick={() => onProductRemove(prod.correlationId)}></div>
                    <div className="heading-6">{prod.description}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        }
        {(products === null || products.length <= 0) &&
          <>
            {loading ? 
              <div className="error-basket semibold">Attendi qualche istante <Loader visible={loading} className="" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></div>
            :
              <div className="error-basket semibold">Il carrello è vuoto</div>
            }
          </>
        }
      </div>

      {dlgConf != null &&
        <DialogMsg conf={dlgConf} ></DialogMsg>
      }
    </>
  );
}

export default Basket;